<template>
  <v-app id="inspire">
    <v-content class="login">
      <v-container fluid fill-height>
        <v-layout align-center justify-center>
          <div class="login-wrapper">
            <v-card class="elevation-12">
              <v-card-text>
                <h1>Login</h1>
                <h2>Merci de vous authentifier</h2>
                <v-form ref="form" v-model="valid" lazy-validation>
                  <v-text-field
                    name="email"
                    label="Email"
                    placeholder="Votre email"
                    type="text"
                    outline
                    v-model="email"
                    :rules="rules.email"
                  ></v-text-field>
                  <v-text-field
                    id="password"
                    name="password"
                    label="Password"
                    type="password"
                    placeholder="*********"
                    outline
                    v-model="password"
                    :rules="rules.password"
                  ></v-text-field>
                </v-form>
                <v-alert
                  :value="!!error"
                  color="error"
                  icon="warning"
                  outline
                >
                  {{error}}
                </v-alert>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="primary" @click="onSubmit">Se connecter</v-btn>
              </v-card-actions>
            </v-card>
          </div>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    data: () => ({
      email: '',
      password: '',
      valid: true,
      error: undefined,
      rules: {
        email: [ v => !!v || 'Un email est requis' ],
        password: [ v => !!v || 'Le mot de passe est requis' ],

      }
    }),
    methods: {
      ...mapActions(['authSuccess']),
      async onSubmit() {
        const valid = this.$refs.form.validate();
        if(!valid) return;

        try {
          const response = await this.$http.post('/api/auth', { email: this.email, password: this.password });
          const token = response.data;
          localStorage.setItem('token', token);
          this.authSuccess(token);
          this.$router.push({ name: 'Home' });
        } catch (err) {
          this.error = 'Les identifiants saisis sont invalides';
        }
      }
    },
  }
</script>

<style scoped>
  /deep/ .theme--light.v-text-field--outline > .v-input__control > .v-input__slot {
    border-width: 1px!important;
  }
  body {
    font-family: "Helvetica Neue",Helvetica,Arial,sans-serif;
  }


  h1, h2 {
    font-weight: normal;
    margin: 10px 0;
  }

  .login-wrapper{
    max-width: 380px;
    width: 380px;
    margin: 100px auto auto auto;
  }
</style>
